import { reactive } from 'vue'

const dirtyPanels = reactive<Record<string, boolean>>({})

export function useUnsavedChanges() {
  function markDirty(key: string): void {
    dirtyPanels[key] = true
  }

  function markClean(key: string): void {
    delete dirtyPanels[key]
  }

  function isDirty(key: string): boolean {
    return dirtyPanels[key] === true
  }

  return { dirtyPanels, markDirty, markClean, isDirty }
}
